<template>
  <main class="team-page">
    <section class="team-hero" v-reveal>
      <div class="team-hero__copy">
        <p class="section-kicker">{{ team.kicker }}</p>
        <h1>{{ team.title }}</h1>
        <p>{{ team.copy }}</p>
      </div>
      <PageMascotVisual />
    </section>

    <section class="team-grid" aria-label="GuildGuardian Team">
      <article
        v-for="(member, index) in team.members"
        :key="member.discord"
        class="team-card"
        :class="`team-card--${member.accent}`"
        v-reveal
        :style="{ '--delay': `${index * 110}ms` }"
      >
        <div class="team-card__media">
          <img :src="memberImages[member.image]" :alt="member.name" />
        </div>
        <div class="team-card__content">
          <div>
            <h2>{{ member.name }}</h2>
            <p>
              <AppIcon name="discord" />
              <span>{{ member.discord }}</span>
            </p>
          </div>

          <div class="team-role-block">
            <span>{{ team.roleLabel }}</span>
            <div class="team-role-list">
              <strong v-for="position in member.positions" :key="position">
                <AppIcon :name="getRoleIcon(position)" />
                <span>{{ position }}</span>
              </strong>
            </div>
          </div>
        </div>
      </article>
    </section>

    <section class="team-recruiting" v-reveal>
      <div>
        <p class="section-kicker">{{ team.recruiting.kicker }}</p>
        <h2>{{ team.recruiting.title }}</h2>
        <p>{{ team.recruiting.copy }}</p>
      </div>
      <a class="action-button action-button--discord action-button--large" :href="team.recruiting.href">
        <AppIcon name="spark" />
        <span>{{ team.recruiting.action }}</span>
      </a>
    </section>
  </main>
</template>

<script>
import AppIcon from './AppIcon.vue'
import PageMascotVisual from './PageMascotVisual.vue'
import meisterKeksImage from '../assets/team-meister-keks.png'
import thorinImage from '../assets/team-thorin.png'
import damagingImage from '../assets/team-damaging.png'

export default {
  name: 'TeamPage',
  components: {
    AppIcon,
    PageMascotVisual
  },
  props: {
    team: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      memberImages: {
        meisterKeks: meisterKeksImage,
        thorin: thorinImage,
        damaging: damagingImage
      }
    }
  },
  methods: {
    getRoleIcon(position) {
      const normalizedPosition = position.toLowerCase()

      if (normalizedPosition.includes('inhaber') || normalizedPosition.includes('owner')) {
        return 'crown'
      }

      if (
        normalizedPosition.includes('developer') ||
        normalizedPosition.includes('entwicklung') ||
        normalizedPosition.includes('backend') ||
        normalizedPosition.includes('frontend') ||
        normalizedPosition.includes('bot')
      ) {
        return 'code'
      }

      if (normalizedPosition.includes('support')) {
        return 'headset'
      }

      if (normalizedPosition.includes('marketing')) {
        return 'megaphone'
      }

      if (normalizedPosition.includes('manager')) {
        return 'team'
      }

      return 'star'
    }
  }
}
</script>
